import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 103 103"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M3 30a3 3 0 0 0-3 3v37a3 3 0 0 0 3 3h24a3 3 0 0 1 3 3v24a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3V76a3 3 0 0 1 3-3h24a3 3 0 0 0 3-3V33a3 3 0 0 0-3-3H83.97a3 3 0 0 0-2.417 1.223L45.64 80.087a3 3 0 0 1-4.61.27L17.828 55.52c-2.22-2.377.4-6.094 3.384-4.802l18.475 7.997a3 3 0 0 0 3.251-.572L72.06 30.638a3 3 0 0 0 .94-2.181V3a3 3 0 0 0-3-3H33a3 3 0 0 0-3 3v24a3 3 0 0 1-3 3zm37 19c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }